import { useContext } from "react";
import { MSTContext } from "../../stores/main";
import { observer } from "mobx-react-lite";
import { Tooltip } from "antd";
import { formatPrimaryShortcut } from "../../utils/shortcutKeys";
import "./UndoRedoButtons.scss";

const UndoIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.46967 4.71967C2.32902 4.86032 2.25 5.05109 2.25 5.25C2.25 5.44891 2.32902 5.63968 2.46967 5.78033L5.46967 8.78033C5.76256 9.07322 6.23744 9.07322 6.53033 8.78033C6.82322 8.48744 6.82322 8.01256 6.53033 7.71967L4.81066 6H9C10.7949 6 12.25 7.45507 12.25 9.25C12.25 11.0449 10.7949 12.5 9 12.5H8C7.58579 12.5 7.25 12.8358 7.25 13.25C7.25 13.6642 7.58579 14 8 14H9C11.6234 14 13.75 11.8734 13.75 9.25C13.75 6.62665 11.6234 4.5 9 4.5L4.81066 4.5L6.53033 2.78033C6.82322 2.48744 6.82322 2.01256 6.53033 1.71967C6.23744 1.42678 5.76256 1.42678 5.46967 1.71967L2.46967 4.71967Z"
      fill="currentColor"
    />
  </svg>
);

const RedoIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5303 4.71967C13.671 4.86032 13.75 5.05109 13.75 5.25C13.75 5.44891 13.671 5.63968 13.5303 5.78033L10.5303 8.78033C10.2374 9.07322 9.76256 9.07322 9.46967 8.78033C9.17678 8.48744 9.17678 8.01256 9.46967 7.71967L11.1893 6H7C5.20508 6 3.75 7.45507 3.75 9.25C3.75 11.0449 5.20507 12.5 7 12.5H8C8.41421 12.5 8.75 12.8358 8.75 13.25C8.75 13.6642 8.41421 14 8 14H7C4.37665 14 2.25 11.8734 2.25 9.25C2.25 6.62665 4.37665 4.5 7 4.5L11.1893 4.5L9.46967 2.78033C9.17678 2.48744 9.17678 2.01256 9.46967 1.71967C9.76256 1.42678 10.2374 1.42678 10.5303 1.71967L13.5303 4.71967Z"
      fill="currentColor"
    />
  </svg>
);

export const UndoRedoButtons = observer(() => {
  const { undoStore } = useContext(MSTContext);

  return (
    <div className="undo-redo-buttons">
      <Tooltip
        title={`Undo (${formatPrimaryShortcut("Z")})`}
        placement="bottom"
      >
        <button
          className={`undo-redo-btn ${!undoStore.canUndo ? "disabled" : ""}`}
          onClick={() => undoStore.undo()}
          disabled={!undoStore.canUndo}
          aria-label="Undo"
        >
          <UndoIcon />
        </button>
      </Tooltip>
      <Tooltip
        title={`Redo (${formatPrimaryShortcut("Z", { shift: true })})`}
        placement="bottom"
      >
        <button
          className={`undo-redo-btn ${!undoStore.canRedo ? "disabled" : ""}`}
          onClick={() => undoStore.redo()}
          disabled={!undoStore.canRedo}
          aria-label="Redo"
        >
          <RedoIcon />
        </button>
      </Tooltip>
    </div>
  );
});
